import * as manager from "./ABTestManager";
import { camelCase, handleize } from "../Helpers/helpers";
import GridLayoutOnPLP from "./GridLayoutOnPLP";

const ABTestClassMap = {
    GridLayoutOnPLP,
};

export default function () {
    const abData = Shopify.theme_settings.ab_tests;
    if (abData.length > 0) {
        abData.forEach((item) => {
            let testVariants = [];
            let nameOfTest = handleize(item.name);
            item.test.forEach((test) => {
                testVariants.push({
                    slug: handleize(test.name),
                    name: test.name,
                    chance: parseFloat(test.chance),
                    onRun: () => {
                        const abTestWrapper = document.querySelector(`[data-ab-test="${nameOfTest}"]`);
                        if (!abTestWrapper) {
                            return;
                        }
                        const className = camelCase(item.name.replace(/Test/g, ""));
                        try {
                            LUC.ABTests[nameOfTest] = new ABTestClassMap[className](handleize(test.name));
                        } catch (error) {
                            console.info(`Error loading class ${className}:`, error);
                        }
                        abTestWrapper.dataset.abTestVariant = handleize(test.name);
                    },
                });
            });

            manager.register({
                id: nameOfTest,
                name: item.name,
                debug: true,
                variants: testVariants,
            });

            manager.run(nameOfTest);
        });
    }
}
